import { generateConversationsDesktopAppConfig } from '@driftt/app-config'
import { DesktopAppConfigIF } from '@driftt/app-config/dist/utils/driftTypes'

import { User } from '../typings/user'

export const getCurrentUser = (state: any): User | undefined => state?.user?.gates && state?.user

export const getCurrentUserField = (field: keyof User) => (state: any) =>
  getCurrentUser(state)?.[field]

export const getUserProperties = (state: any): any | undefined => getCurrentUser(state)?.settings

export const getConfig = (currentUser: User): DesktopAppConfigIF =>
  generateConversationsDesktopAppConfig(currentUser) as DesktopAppConfigIF

export const getHasAbility = (ability: keyof DesktopAppConfigIF) => (state: any): boolean => {
  const currentUser = getCurrentUser(state)
  const config = currentUser && getConfig(currentUser)

  return !config ? false : config[ability] ?? false
}
